import React, { useEffect } from 'react'
import { Container, ListGroup } from 'react-bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import about from '../../assets/images/gn_bank_cover.jpeg'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faLocation} from '@fortawesome/free-solid-svg-icons/faLocation'
import SimpleHero from '../../components/SimpleHero/SimpleHero'
import './contact.css'

const Contact = () => {
  useEffect(() => {
    // Load Assembly chat script
    const script = document.createElement('script');
    script.src = 'https://cdn.assembly.com/assembly.js';
    script.async = true;
    script.setAttribute('data-assembly-id', 'YOUR_ASSEMBLY_ID'); // Replace with your actual Assembly ID
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script on unmount
      const existingScript = document.querySelector('script[data-assembly-id]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <Container fluid={true}>
      <SimpleHero
        title="We're here to help"
        subtitle="Call +1 (773) 624‑2000,  or visit 4619 S. King Drive, Chicago, IL."
        primaryLabel="Find a location"
        primaryHref="/location"
        variant="sofi"
        imageSrc={about}
        imageAlt="Contact GN Bank"
        imageOn="right"
        tiltImage
        badges={["Phone","Chat","Visit"]}
      />

      <main className="contact-main">
        <div className="container px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            {/* Chat Section */}
            <div className="col-md-10 col-lg-8 col-xl-8 mt-5">
              <div className="contact-card chat-card">
                <div className="contact-card-header">
                  <h2 className="contact-title">Chat with Us</h2>
                </div>
                <div className="contact-card-body">
                  <p className="contact-description">
                    Have a question? Our team is here to help! Start a conversation with us via
                  </p>
                  <a 
                    href="https://portal.gnbank.net" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="portal-link"
                  >
                    Customer Support Portal
                  </a>
                  <div className="chat-container">
                    <div id="assembly-chat-container"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information Cards */}
            <div className="col-md-10 col-lg-8 col-xl-8 mt-4">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="contact-card info-card">
                    <div className="contact-icon-wrapper phone-icon">
                      <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                    </div>
                    <h3 className="contact-info-title">Phone</h3>
                    <a href="tel:+17736242000" className="contact-link">
                      +1 (773) 624-2000
                    </a>
                    <p className="contact-info-subtitle">Call us anytime</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="contact-card info-card">
                    <div className="contact-icon-wrapper location-icon">
                      <FontAwesomeIcon icon={faLocation} className="contact-icon" />
                    </div>
                    <h3 className="contact-info-title">Location</h3>
                    <a 
                      href="https://www.google.com/maps/search/?api=1&query=GN+Bank+Chicago"
                      className="contact-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      4619 S. King Drive<br />
                      Chicago, IL 60653
                    </a>
                    <p className="contact-info-subtitle">Visit us in person</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Container>
  )
}

export default Contact
